<template>
  <div style="width:100vw; position: relative; left: -8px;
    background-color: rgba(255, 255, 255, 0.5);">

        <div :style="{width: getScreenWidth > 500 ? '70%' : '100%', margin: '0 auto'}">
            <div class="flexSpaceBetween" style="text-align: center;">
                <span class="heading"><h1>{</h1></span><span class="heading" style="top: 50px; position: relative;">What can we do for you? </span><span class="heading"><h1>}</h1></span>
            </div>        
        </div>
        <div class="flexSpaceBetween" style="flex-wrap: wrap; width: 70%; margin: 0 auto;">

            <div style="width: 35%; margin: 5%; text-align: center;">
                <img src="https://raizzoncdn.b-cdn.net/home/new/cloud-settings.png" style="max-width: 200px;"  width="100%" alt="">
                <h2>Full Stack Cloud Solution</h2>
                <span>
                    (Web app + Mobile app + Back office app)
                </span>
            </div>

            <div style="width: 35%; margin: 5%; text-align: center;">
                <img src="https://raizzoncdn.b-cdn.net/home/new/structure.png" style="max-width: 200px;"  width="100%" alt="">                
                <h2>Infrastructure Maintenance</h2>
                <span>
                    Maintenance of pre-built programs and cloud solutions.
                </span>
            </div>

            <div style="width: 35%; margin: 5%; text-align: center;">
                <img src="https://raizzoncdn.b-cdn.net/home/new/design-software.png" style="max-width: 200px;"  width="100%" alt="">                                
                <h2>Architecture Planning</h2>
                <span>
                    (Software solution + Server planning)
                </span>
            </div>

            <div style="width: 35%; margin: 5%; text-align: center;">
                <img src="https://raizzoncdn.b-cdn.net/home/new/social-media.png" style="max-width: 200px;" width="100%" alt="">                                
                <h2>Branding and Promotions</h2>
                <span>
                    Brand design, promotion on digital mediums, strategise sustainable organic traffic generation.
                </span>
            </div>
        </div>
        
  </div>
</template>

<script>
export default {
    computed: {
        getScreenWidth() {
            return window.screen.width
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Section5.vue